/**
 * load chapter html file
 * html mount
 * 根据chapter的path加载最新分析任务, 加载所有比较组
 * load tools
 * 根据每个tool的saveFilePng判断是否每个比较组都存在图片,不存在的则需要加载图表并生成图片与pdf
 */
import $ from '@/assets/jquery/jquery-vendor.js';
import { userFileChapterHtml, getChapterTool, userFileList, userFileRead, userFileWrite, userFileUpdate } from '@/plugins/api';
import { getImgData, getPdfData } from '@/plugins/chart';
import Vue from 'vue';
let logs = [];
export default {
  props: ['chapter', 'param', 'debug'], // 章节， 文件读取参数:fileReadParam
  data () {
    return {
      htmlCode: '',
      jsCode: '',
      taskList: [],
      tools: [],
      charts: [],

      chapterLoading: false,

      tmpChartReady: false,
      tmpChart: null,
      tmpChartStatus: { ready: false },
      tmpChartStyle: {},
      tmpChartProps: null
    }
  },
  async mounted () {
    logs = [];
    try {
      await this.init();
    } catch (ex) {
      console.error(ex);
    } finally {
      if (this.debug) console.log(logs.join('\n'))
      this.$parent.setReadyState();
    }
  },
  computed: {
    tmpChartContainerId () { return `chart_tmp_container_${this.chapter.chapterId}` }
  },
  methods: {
    isStaticChart (toolResultType) {
      return toolResultType == 'Table' || toolResultType == 'Image' || toolResultType == 'Html';
    },
    // 加载章节内容
    async init () {
      // console.log(this.chapter._cno+'=>'+this.chapter.name);
      // console.log(JSON.stringify(this.param));

      logs.push('start init chapter:' + this.chapter._cno + ' ' + this.chapter.name);
      // >>>>>>>>>> 加载章节的html文件
      await this.initChapterHtml();
      // >>>>>>>>>>>>> 初始化最新的分析任务
      await this.initTask();
      // >>>>>>>>>>> 加载章节中的小工具
      logs.push('  start load chapter tools');
      await getChapterTool(this.chapter.chapterId).then(res => this.tools = res.data || [])
      logs.push('  end load chapter tools, length:' + this.tools.length);
      if (this.tools.length) {
        // >>>>>>>>>>>> 保存小工具结果: 循环task及vs
        logs.push('  start write tools result');
        await this.writeToolResults();
        logs.push('  end write tools result');
        // 更新最新任务及最新比较组的目录最后修改时间, 以便于下次加载最新的默认图表
        await this.updateLatest();
        // 移除临时图表组件
        if (this.tmpChartReady) this.tmpChartReady = false;
        // >>>>>>>>>>>> 嵌入小工具图表
        await this.embedToolResults();
      }
      // >>>>>>>>>>> 执行jsCode
      await this.runJsCode();
      logs.push('end load chapter' + this.chapter._cno);
    },

    async initChapterHtml () {
      logs.push('  start init html file');
      await userFileChapterHtml({ path: this.chapter.htmlFile }).then(res => {
        let d = res.data;
        if (d) {
          this.htmlCode = d.replace(/<script.*?>([\s\S]+)<\/script>/, (a, b) => {
            this.jsCode = b;
            return '';
          });
        }
      })
      logs.push('  end init html file');
    },
    async initTask () {
      logs.push('  start init task');
      let path = this.chapter.path;
      if (path) {
        path = this.Utility.fmtExpress(path, this.param);
        let parent = path.substring(0, path.lastIndexOf('/')), dir = path.substring(path.lastIndexOf('/') + 1);
        await userFileList({ path: parent, regex: `${dir}.*`, sort: 'desc' }).then(res => this.taskList = res.data || []);
        if (this.taskList && this.taskList.length) {
          this.param.task = this.taskList[0].name;
          for (let i = 0; i < this.taskList.length; i++) {
            let task = this.taskList[i];
            await userFileList({ path: `${parent}/${task.name}`, regex: '(.+_vs_.+)|(.+_oneway)', sort: 'desc' }).then(res => task.vsList = res.data || [])
          }
          this.param.vsList = this.taskList[0].vsList;
        }
      }
      logs.push('  end init task');
    },
    async writeToolResults () {
      for (let i = 0; i < this.tools.length; i++) {
        let tool = this.tools[i];
        if (this.isStaticChart(tool.toolResultType)) {
          logs.push('        skip tool save of static chart: ' + tool.toolName);
          continue;
        }
        if (!tool.saveFlag) {
          logs.push('        skip tool save of not saveFlag:' + tool.toolName);
          continue;
        }
        // task -> vs -> sp
        let saveFilePng = tool.saveFilePng || '', taskFlag = saveFilePng.indexOf('${task}') != -1, vsFlag = saveFilePng.indexOf('${vs}') != -1, spFlag = saveFilePng.indexOf('${sp}') != -1;
        if (taskFlag) {
          for (let i = 0; i < this.taskList.length; i++) {
            let task = this.taskList[i];
            if (vsFlag) {
              let vsList = task.vsList;
              for (let m = 0; m < vsList.length; m++) {
                let vs = vsList[m];
                if (spFlag) {
                  for (let x = 0; x < this.param.sps.length; x++) await this.writeToolResult(tool, task.name, vs.name, this.param.sps[x]);
                } else await this.writeToolResult(tool, task.name, vs.name);
              }
            } else if (spFlag) {
              for (let x = 0; x < this.param.sps.length; x++) await this.writeToolResult(tool, task.name, null, this.param.sps[x]);
            } else {
              await this.writeToolResult(tool, task.name);
            }
          }
        } else {
          if (spFlag) {
            for (let x = 0; x < this.param.sps.length; x++) await this.writeToolResult(tool, null, null, this.param.sps[x]);
          } else await this.writeToolResult(tool);
        }
      }
    },
    // 自动存储图表文件不需要fn,fn仅作为图片的文件名选择使用
    async writeToolResult (tool, task, vs, sp, fn) {
      logs.push('        start write chart result:' + tool.toolName + ', task=' + task + ', vs=' + vs + ', sp=' + sp);
      let exists;
      await userFileRead({ path: this.Utility.fmtExpress(tool.saveFilePng, { ...this.param, task: task, vs: vs, sp: sp, fn: fn }), stream: false }).then(res => exists = res.data);
      if (exists) {
        logs.push('        skip write chart result of exists');
        return;
      }

      this.tmpChartStatus.ready = false;
      let props = { status: this.tmpChartStatus, forceUnLoading: true };
      let chart = await this.initChart(tool, task, vs, sp, fn, props);
      this.tmpChart = chart;
      this.tmpChartProps = props;
      this.tmpChartReady = true;
      await this.$nextTick().then(async () => {
        let chartCpt = this.$refs[this.tmpChartContainerId];
        await new Promise(resolve => {
          let timeouts = 0;
          let timer = setInterval(async () => { // 一直加载chart的ready状态
            if (this.tmpChartStatus.ready) {
              clearInterval(timer);
              // 保存图片与pdf(静态图片类型的不需要保存图片与pdf)
              await this.writeToolResultFiles(chartCpt, tool, task, vs, sp, fn);
              this.tmpChartReady = false;
              resolve();
            } else {
              timeouts += 500;
              if (timeouts >= 10000) {  // 10秒认为超时
                clearInterval(timer);
                this.tmpChartReady = false;
                resolve();
              }
            }
          }, 500)
        })
      });
      logs.push('        end write chart result');
    },
    async updateLatest () {
      if (this.param.task) {
        await userFileUpdate({ path: `/${this.param.type}/${this.param.xmh}/Result/${this.param.schema}/${this.param.task}` });
      }
      if (this.param.vsList.length) {
        for (let i = 0; i < this.param.vsList.length; i++) {
          let vs = this.param.vsList[i].name;
          await userFileUpdate({ path: `/${this.param.type}/${this.param.xmh}/Result/${this.param.schema}/${this.param.task}/${vs}` });
        }
      }
    },

    // 加载分析工具
    async embedToolResults () {
      for (let i = 0; i < this.tools.length; i++) {
        let tool = this.tools[i], vs = this.param.vsList.length ? this.param.vsList[0].name : null, sp, fn, props = { forceUnLoading: true };
        if (tool.dataSource.indexOf('${sp}') != -1) sp = this.param.sps[0];
        // if (tool.dataSource.indexOf('${fn}') != -1) fn = this.param.fns[0];
        let chart = await this.initChart(tool, this.param.task, vs, sp, fn, props);
        this.charts.push(chart ? { domId: tool.domId, cpt: chart, props: props } : {});
      }
      await this.$nextTick(() => {
        for (let i = 0; i < this.tools.length; i++) {
          let domId = this.tools[i].domId;
          let domEl = document.getElementById(domId);
          if (!domEl) logs.push(`      domId not exists:${domId}`)
          else domEl.appendChild(this.$refs[`chart_${domId}`][0].$el);
        }
      })
    },

    async initChart (tool, task, vs, sp, fn, props) {
      let domId = tool.domId;
      let domEl = document.getElementById(domId);
      if (!domEl) return null;

      let vp = { ...this.param, task: task, vs: vs, sp: sp, fn: fn };
      let dataSourceParam = { path: this.Utility.fmtExpress(tool.dataSource, vp) }
      let toolResultType = tool.toolResultType;
      let paramValue = await this.getParamConfig(tool, task, vs, sp, fn); // 存储的图表参数json文件
      let { width, extWidth } = { ...paramValue }
      delete paramValue.width
      delete paramValue.extWidth
      props.paramValue = paramValue
      let chart;
      await import(`@/views/Component/ChartLib/${toolResultType}`).then(res => {
        //获取对应的key
        if (tool.optionBuildConfig) {
          props.config = JSON.parse(
            this.Utility.fmtExpress(tool.optionBuildConfig, vp)
          );
        }
        this.Utility.deepMerge(props, {
          tool: { type: toolResultType, params: tool.toolResultParams, coder: tool.coder },
          dataSourceParam: dataSourceParam, embed: true,
          width: width || '400px', extWidth: extWidth || '400px',
          chartContainerId: 'chart_' + domId, exportFileName: tool.toolName
        })
        chart = res.default;
      })
      return chart;
    },

    // 存入报告
    async writeToolResultFiles (chartCpt, tool, task, vs, sp, fn) {
      if (this.isStaticChart(tool.toolResultType)) return;
      logs.push('             start write chart result files:' + tool.toolName);
      if (!chartCpt.noData) {
        // 暂停1秒后再去获取图表组件的svg
        await new Promise(resolve => { setTimeout(() => { resolve() }, 1000) })
        let cpv = chartCpt.paramFormData;
        let saveFileParam = this.Utility.fmtExpress(tool.saveFileParam, { ...this.param, task: task, vs: vs, sp: sp, fn: fn });
        // 获取imgData,存储为图片
        let svgNode = chartCpt.getSvg();
        let sw = svgNode.width.baseVal.value, sh = svgNode.height.baseVal.value, dpi = 150, scale = dpi / 72;
        let w = parseInt(sw * scale), h = parseInt(sh * scale);
        let imgData = await getImgData(svgNode, w, h);
        let saveFilePng = this.Utility.fmtExpress(tool.saveFilePng, { ...this.param, task: task, vs: vs, sp: sp, fn: fn });
        let pdfData = await getPdfData(svgNode, w, h, dpi);
        let saveFilePdf = saveFilePng.substring(0, saveFilePng.lastIndexOf('.')) + '.pdf';
        let formData = new FormData();
        formData.append(saveFileParam, JSON.stringify(cpv)); // 存储图表参数
        formData.append(saveFilePng, imgData); // 存储图片
        formData.append(saveFilePdf, pdfData); // 存储pdf
        await userFileWrite(formData);
      }
      logs.push('             end write chart result');
    },

    async runJsCode () {
      let _fn;
      try {
        if (this.jsCode) {
          _fn = new Function('ξ', this.jsCode);
          await _fn(this);
        }
      } catch (err) {
        if (this.debug) {
          console.error(`========== ${this.chapter._cno} ${this.chapter.name} ==========`)
          console.error(_fn);
          console.error(err);
        }
      }
    },

    async getParamConfig (tool, task, vs, sp, fn) {
      let paramConfig = tool.paramConfig ? JSON.parse(tool.paramConfig) : {};
      if (tool.saveFlag) {
        let cpv = {};
        if (tool.saveFileParam) {
          let saveFileParam = this.Utility.fmtExpress(tool.saveFileParam, { ...this.param, task: task, vs: vs, sp: sp, fn: fn });
          await userFileRead({ path: saveFileParam }).then(res => {
            let d = res.data;
            if (d) cpv = JSON.parse(d);
          })
        }
        this.Utility.deepMerge(paramConfig, cpv);
      }
      return paramConfig;
    },

    // =================================== 导出pdf的时候将图表全部替换为图片??

    // ==================================== 提供给html调用的函数
    // 读取文件列表
    userFileList (param) {
      return $.ajax({ method: 'post', url: `${this.Utility.userApi}/api/user/file/list`, contentType: 'application/json;charset=UTF-8', headers: { token: Vue.ls.get('token') }, data: JSON.stringify(param), async: false }).responseJSON.data;
    },
    // 读取用户文件内容
    userFileRead (param) {
      return $.ajax({ method: 'post', url: `${this.Utility.userApi}/api/user/file/read`, contentType: 'application/json;charset=UTF-8', headers: { token: Vue.ls.get('token') }, data: JSON.stringify(param), async: false }).responseJSON.data;
    },
    // 存入报告
    async save (domId, vs, sp, fn) {
      let chartCpt = this.$refs[`chart_${domId}`][0];
      if (chartCpt.noData) {
        this.$message.error('暂无数据');
        return;
      }
      let index = this.tools.findIndex(t => t.domId == domId);
      let tool = this.tools[index];
      await this.writeToolResultFiles(chartCpt, tool, this.param.task, vs, sp, fn);
      this.$message.success('保存成功');
    },
    // 更新图表(vs:比较组, sp:样品名称, fn:文件名称)
    async updateChart (domId, vs, sp, fn) {
      this.chapterLoading = true;
      let index = this.tools.findIndex(t => t.domId == domId);
      let tool = this.tools[index], props = { forceUnLoading: true };
      let chart = await this.initChart(tool, this.param.task, vs, sp, fn, props);
      this.$set(this.charts, index, { domId: tool.domId, cpt: chart, props: props })
      this.$nextTick(async () => {
        let chartCpt = this.$refs[`chart_${domId}`][0];
        await chartCpt.init();
        this.chapterLoading = false;
      })
    }

  },
}